import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Sector } from '../models/Sector';
import { SectorService } from '../services/sector.service';
declare var $: any;
import * as jQuery from 'jquery';

@Component({
  selector: 'app-home-carousel',
  templateUrl: './home-carousel.component.html',
  styleUrls: ['./home-carousel.component.css']
})
export class HomeCarouselComponent implements OnInit, AfterViewInit {

  sectores: Sector[];

  constructor(
    private sectorService: SectorService
  ) { }

  ngOnInit() {

    

    this.sectorService.getSectores().subscribe( res => {
      this.sectores = res;
    } )


  }
  ngAfterViewInit() {
    $(document).ready(function () {


      // Testimonials carousel (uses the Owl Carousel library)
     


    })
  }

}
